import Skillset from './Skillset';

export default Skillset;